import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getPaymentsByTenancyId } from "../TenancyApi";
import { NumericFormat } from "react-number-format";
import TenancyDetailsByLTTI from "../TenancyDetailsByLTTI";
import MakePayment from "../MakePayment";
import { formatDateText, updateRows } from "../CommonFunctions";

export default function PaymentDetails({ tenancyId, tenancyDetails, customersDetails }) {
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [openFullList, setOpenFullList] = useState(false);
  const [showTenancyDetailsByLTTIModal, setShowTenancyDetailsByLTTIModal] = useState(false);
  const [showTakePaymentModal, setShowTakePaymentModal] = useState(false);

  useEffect(() => {
    if (tenancyId) {
      getApiPaymentsByTenancyId(tenancyId);
    }
  }, [tenancyId]);


  const getApiPaymentsByTenancyId = async (tenancyId) => {
    try {
      const response = await getPaymentsByTenancyId(tenancyId);
      if (response) {
        setPaymentDetails(response);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePaymentSave = async(paymentJson)=>{
   
    setPaymentDetails(prevRows =>
        updateRows(prevRows, "create", paymentJson.id, paymentJson)
    );

    
  }
  const handlePaymentUpdate = async(paymentJson)=>{
    
  }

  // Show only the latest 3 entries
  const latestThree = paymentDetails.slice(0, 3);

  return (
    <>
      <Box
        sx={{
          borderRadius: 1,
          overflow: "hidden",
          bgcolor: "white",
          px: 2,
          mb: 2,
        }}
      >
        <Box component={Paper} elevation={3}>
          {/* HEADER */}
          <Box
            sx={{
              bgcolor: "#e8f3ff",
              px: 1.5,
              py: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              minHeight: "18px",
            }}
          >
            <Typography
              sx={{ fontWeight: 700, fontSize: "0.95rem", lineHeight: 0.2 }}
            >
              Payment Details
            </Typography>

            <Box>
                <Link
                style={{
                    color: "#0066ff",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    textDecoration: "underline",
                    marginRight:50
                }}
                onClick={() => setShowTenancyDetailsByLTTIModal(true)}
                >
                Payment Summary
                </Link>

                <Link
                to="#"
                style={{
                    color: "#0066ff",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    textDecoration: "underline",
                }}
                onClick={() => setShowTakePaymentModal(true)}

                >
                Take Payment
                </Link>
            </Box>
          </Box>

          {/* TABLE */}
          <TableContainer>
            <Table
              sx={{
                "& th": {
                  fontWeight: 600,
                  bgcolor: "white",
                  borderBottom: "1px solid #e3e3e3",
                  py: 1,
                  px: 2,
                },
                "& td": {
                  borderBottom: "1px solid #efefef",
                  fontSize: "0.9rem",
                  py: 1,
                  px: 2,
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Paid date</TableCell>
                  <TableCell>Credit card amount</TableCell>
                  <TableCell>Cash amount</TableCell>
                  <TableCell>Other amount</TableCell>
                  <TableCell>Total</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {/* If no payments */}
                {paymentDetails.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      No payment records found.
                    </TableCell>
                  </TableRow>
                )}

                {/* Latest 3 rows */}
                {latestThree.map((p) => (
                  <TableRow key={p.id}>
                    <TableCell>{formatDateText(p.actualPaymentDate)}</TableCell>
                    <TableCell><NumericFormat value={p.creditCardAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>
                    <TableCell><NumericFormat value={p.cashAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>
                    <TableCell><NumericFormat value={p.otherAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>
                    <TableCell><NumericFormat value={p.creditCardAmount + p.cashAmount + p.otherAmount} 
                    thousandSeparator prefix={'$'} displayType="text"/></TableCell>

                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* LOAD MORE */}
          {paymentDetails.length > 3 && (
            <Box sx={{ textAlign: "center", py: 1.3 }}>
              <Typography
                sx={{
                  color: "#0066ff",
                  fontWeight: 600,
                  fontSize: "0.9rem",
                  cursor: "pointer",
                  "&:hover": { textDecoration: "underline" },
                }}
                onClick={() => setOpenFullList(true)}
              >
                Load More
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {/* FULL PAYMENT LIST DIALOG */}
      <Dialog
        open={openFullList}
        onClose={() => setOpenFullList(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ fontWeight: 700 }}>All Payments</DialogTitle>

        <DialogContent dividers>
          <Table fullWidth>
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Mode</TableCell>
                <TableCell>Status</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {paymentDetails.map((p) => (
                <TableRow key={p.id}>
                  <TableCell>{p.date}</TableCell>
                  <TableCell>${p.amount}</TableCell>
                  <TableCell>{p.mode}</TableCell>
                  <TableCell>{p.status}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenFullList(false)}>Close</Button>
        </DialogActions>
      </Dialog>

       {showTenancyDetailsByLTTIModal && <TenancyDetailsByLTTI
            longTermTenancyId={tenancyDetails.longTermTenancyId}
            showTenancyDetailsByLTTIModal={showTenancyDetailsByLTTIModal}
            setShowTenancyDetailsByLTTIModal={setShowTenancyDetailsByLTTIModal}
        />}

        {showTakePaymentModal && 
            <MakePayment value={{
                tenancyId: tenancyId,
                tenancyDetails: tenancyDetails,
                customersDetails: customersDetails
            }} handlePaymentSave={handlePaymentSave}/>
        }
    </>
  );
}
